exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".options-sty[data-v-319699ba]{color:#290202}.pageation[data-v-319699ba]{padding:30px 10px 20px;border-top:0}.dialog-footer[data-v-319699ba]{padding-bottom:20px}.dialog-footer .btn[data-v-319699ba]{width:30%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-319699ba","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/ent-access/entSign.vue
// module id = +bf4
// module chunks = 48